<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <hr />
      <b-card border-variant="info" align="center" no-body>
        <template v-slot:header>
          <h6>Google maps Tracking COllector</h6>
        </template>

        <GmapMap :center="center" :map-type-id="mapTypeId" :zoom="5">
          <GmapMarker
            v-for="(item, index) in markers"
            :key="index"
            :position="item.position"
            @click="center = item.position"
          />
        </GmapMap>

      </b-card>
    </b-card>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import debitur from "../../apis/debitur";
toastr.init();

export default {
  data() {
    return {
      model: { nasabahkey: "" },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
      },
      center: { lat: -3.350235, lng: 111.995865 },
      mapTypeId: "terrain",
      markers: [
        { position: { lat: -6.261212, lng: 106.796400 } },
        { position: { lat: -0.48585, lng: 117.1466 } },
        { position: { lat: -6.9127778, lng: 107.6205556 } }
      ],
      isBusy: false
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "nomor",
          thStyle: "width:50px",
          label: "No."
        },
        {
          key: "crewnik",
          label: "NIK",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "collector_name",
          label: "Nama Kolektor",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "startdate",
          label: "Start Date",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "enddate",
          label: "End Date",
          thClass: "text-center",
          sortable: true
        }
      ];
      return fields;
    }
  },
  created: async function() {
    if (this.$route.params.nasabahkey) {
      //toastr.info("Loading Collection History, please wait");
      try {
        this.model.nasabahkey = this.$route.params.nasabahkey;
        this.getData();
        //toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    }
  },
  methods: {
    async getData() {
      const [datadebitur, datacollection] = await debitur.historycollection(this.model.nasabahkey);
      this.model = datadebitur;
      this.tblData.items = datacollection;
    },
    async exporthistoryxls() {
      try {
        console.log("#this.tblDataX: ", this.tblData);
        await debitur.exporthistoryxls(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.vue-map-container {
  height: 450px;
  max-width: 992px;
  width: 100%;
}
</style>
